

import numbro from "numbro";

export const toUpper = (str) => {
  return str ? str.toUpperCase() : '';
};

export const capitalizeFirstLetter = (str) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

// export const formatZARCurrency = (amount) => {
//   return new Intl.NumberFormat('en-ZA', {
//     style: 'currency',
//     currency: 'ZAR',
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(amount);
// };

export const formatZARCurrency = (amount) => {
  return new Intl.NumberFormat('en-ZA', {
    currency: 'ZAR',
    style: 'currency',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(amount).replace('R','');
};

export function formatFriendlyNumber(value) {
  let it = Number(value);
  if (Math.abs(it) >= 1_000_000) {
    // millions, one decimal place, suffix (M)
    return numbro(it).format(
      {
        average: true
      }
    );
  }

  if (Math.abs(it) >= 1_000) {
    // thousands, one decimal place, suffix (k)
    return numbro(it).format({
      average: true
    });
  }

  // plain number for < 1000
  return numbro(it).format("0,0");
}


export function formatFriendlyCurrency(value) {
  let it = Number(value);
  if (Math.abs(it) >= 1_000_000) {
    // millions, one decimal place, suffix (M)
    return numbro(it).formatCurrency(
      {
        currencySymbol: "R",
        mantissa: 2,
        average: true
      }
    );
  }

  if (Math.abs(it) >= 1_000) {
    // thousands, one decimal place, suffix (k)
    return numbro(it).format({
      currencySymbol: "R",
      mantissa: 2,
      average: true
    });
  }

  // plain number for < 1000
  return numbro(it).format("0,0");
}

